import React from "react";
import { useTranslation } from "react-i18next";

import { Button } from "@components/buttons";
import { useRootAppStore } from "@hooks";
import { Modal } from "@lib/modal";
import { observer } from "mobx-react";
import { useFixBody } from "@state/hooks/shared";

export default observer(function GracePeriodConfirmationPopup() {
	const { t } = useTranslation();

	const { gracePeriodStore, userAuthStore } = useRootAppStore();

	useFixBody(true, gracePeriodStore.isActive);

	if (!userAuthStore.isLoggedIn) {
		gracePeriodStore.hidePopup();
		return null;
	}

	return (
		<Modal>
			<div className="popup">
				<div className="popup__card">
					<div className="popup__header">
						{t("USER.POPUPS.GRACE_PERIOD.TITLE")}
					</div>
					<div className="popup__body">
						<ul className="list list--disc message--limits">
							<li>
								{t("USER.POPUPS.GRACE_PERIOD.GREETING_INFO")}
							</li>
							<li>
								{t("USER.POPUPS.GRACE_PERIOD.LASTING_INFO")}
							</li>
							<li>
								{t("USER.POPUPS.GRACE_PERIOD.DEPOSIT_INFO")}
							</li>
							<li>
								{t("USER.POPUPS.GRACE_PERIOD.WITHDRAWAL_INFO")}
							</li>
							<li>
								{t(
									"USER.POPUPS.GRACE_PERIOD.VERIFICATION_INFO"
								)}
							</li>
						</ul>
						<p>{t("USER.POPUPS.GRACE_PERIOD.CONFIRM_MESSAGE")}</p>
					</div>
					<div className="popup__footer">
						<button
							className="popup__footer__btn btn btn--sml btn--primary--inverted"
							onClick={gracePeriodStore.hidePopup}
							type="button"
						>
							{t("COMMON.CANCEL")}
						</button>
						<Button
							className="popup__footer__btn btn btn--sml btn--primary"
							onClick={async () => {
								await gracePeriodStore.acceptGracePeriod();
								gracePeriodStore.hidePopup();
							}}
							type="submit"
							btnText={t("COMMON.CONFIRM")}
						></Button>
					</div>
				</div>
			</div>
		</Modal>
	);
});
